import fetch from "../fetch";

export default ({ saleId, propertyId }) =>
  fetch({
    path: `/re/sales/${saleId}/props/${propertyId}`,
    method: "PUT"
  });
